import { Navigate, useLocation } from "react-router-dom";
import { preferredLocalePrefix, withLocalePrefix } from "../../utils/localePaths";

export const RootLocaleRedirect = () => (
  <Navigate to={withLocalePrefix("/", preferredLocalePrefix())} replace />
);

export const LegacyLocaleRedirect = () => {
  const location = useLocation();
  const target = `${withLocalePrefix(location.pathname, preferredLocalePrefix())}${location.search}${location.hash}`;
  return <Navigate to={target} replace />;
};
